<template>
  <v-col class="pa-0">
    <v-row>
      <v-col
        cols="12"
      >
        <v-menu
          ref="menu_from"
          v-model="menuFrom"
          :close-on-content-click="false"
          :return-value.sync="from"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="from"
              :label="$t('from')"
              prepend-icon="event"
              readonly
              dense
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="from"
            first-day-of-week="1"
            :max="to"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="$refs.menu_from.save(null)"
            >
              {{ $t('clear') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="menuFrom = false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu_from.save(from)"
            >
              {{ $t('ok') }}
            </v-btn>
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="menu_to"
          v-model="menuTo"
          :close-on-content-click="false"
          :return-value.sync="to"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="to"
              :label="$t('to')"
              prepend-icon="event"
              readonly
              dense
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="to"
            first-day-of-week="1"
            :min="from"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="$refs.menu_to.save(null)"
            >
              {{ $t('clear') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="menuTo = false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu_to.save(to)"
            >
              {{ $t('ok') }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn
          v-if="from !== '' || to !== ''"
          color="red"
          @click="doRemoveFilter"
        >
          Ryd
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
          v-if="from !== '' || to !== ''"
          color="blue"
          @click="doSetFilter"
        >
          Gem
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  export default {
    props: {
      filterName: {
        type: String,
        default: '',
      },
      fromValue: {
        type: String,
        default: '',
      },
      toValue: {
        type: String,
        default: '',
      },
      setFilter: {
        type: Function,
        default: (from, to) => console.log(from, to),
      },
    },
    data () {
      return {
        from: '',
        to: '',
        menuTo: null,
        menuFrom: null,
      }
    },
    mounted: function () {
      this.from = this.fromValue
      this.to = this.toValue
    },
    methods: {
      doSetFilter: function () {
        this.$emit('filter-added', {
          [this.filterName]: { from: this.from, to: this.to },
        })
      },
      doRemoveFilter: function () {
        this.$emit('filter-remove', this.filterName)
      },
      clearFilter: function () {
        this.from = ''
        this.to = ''
        this.doRemoveFilter()
      },
    },
  }
</script>
